import React from 'react'
import Navbar from './common/navbar'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 onest">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar />
      </div>
      <main className="pt-20 py-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-full">
          {children}
        </div>
      </main>
    </div>
  )
}

export default Layout